module.exports = __webpack_public_path__ + "img/tishi.80a0ee3d.png";